<template>
	<layout-container v-if="child.type==='container'" :block="child"
	                  @activateMe="activateMe"
	                  :block-id="child.id" :index="childIndex" :level="level+1" />
	<layout2-step-form v-else-if="child.type==='twoStepForm'" :block="child"
	                   @activateMe="activateMe"
	                   :block-id="child.id" :index="childIndex" />

	<div v-else :class="{current: child.selected}" :key="childId" :id="'field' + childIndex"
		     class="field title child-title"
		   :style="{paddingLeft:(level*10)+'px'}" @click.stop="activateMe({block:child,event:$event})">
      <span>
        <span class="icon">
            <inline-svg :src="require(`@/assets/page/img/sidebar/${child.type}.svg`)"/>
        </span>
        {{ child.type}}
        {{ child.attributes.advanced.cssId ? ' (#' + child.attributes.advanced.cssId + ')' : ''}}
      </span>
			<div class="wrapper_input dash-buttons"
			     :class="[{'lock_show': child.editLock}, {'eye_show': child.responsive ? !child.responsive[view]:false}]">
				<a class="layers_item_btn lock_btn" @click.stop="lockEditElement()">
					<img src="@/modules/page-editor/src/assets/img/sidebar/lock_icon.svg" alt="">
				</a>
				<a class="layers_item_btn eye_btn" @click.stop="eyeClick()">
					<img src="@/modules/page-editor/src/assets/img/sidebar/eye_icon.svg" alt="">
				</a>
			</div>
		</div>
</template>

<script>
import {mapGetters} from "vuex";
const LayoutChild = () => import("@/modules/page-editor/src/components/sidebar/layout/layout_child");
const LayoutContainer = () => import("@/modules/page-editor/src/components/sidebar/layout/layout_container");
const Layout2StepForm = () => import("@/modules/page-editor/src/components/sidebar/layout/layout_2StepForm");

export default {
	name: "layoutChild",
	components: {LayoutChild,LayoutContainer,Layout2StepForm},
	props: ['child', 'childId', 'childIndex', 'level'],

	computed:{
		...mapGetters(['current_popup']),
		view() {
			return this.$store.state.page.view
		},
	},
	methods:{
		lockEditElement() {
			if(this.child.editLock) {
				this.$store.dispatch('PAGE_EDIT_FIELD',
						{id:this.childId, field: 'editLock', value: false, type:this.child.type});
			} else {
				this.$store.dispatch('PAGE_EDIT_FIELD',
						{id:this.childId, field: 'editLock', value: true, type:this.child.type});
			}
		},
		eyeClick() {
			let getElementResponsive = this.child.responsive || {
				desktop: true,
				mobile: true,
				tablets: true
			};

			getElementResponsive[this.view] = !getElementResponsive[this.view];
			this.$store.dispatch('PAGE_EDIT_FIELD',
					{id:this.childId, field: 'responsive', value: getElementResponsive, type:this.child.type});
		},
		// toggleSection(ev) {
		// 	var parent = ev.target.parentElement;
		// 	parent.classList.toggle('active');
		// 	ev.target.classList.toggle('active');
		// 	// var isActive = parent.classList.contains('active');
		// 	this.activateMe();
		// },
		activateMe(ev) {
			this.$emit('activateMe', ev)
		},
	}
}
</script>

<style lang="scss" scoped>
.dash-buttons {
}
</style>
